module.exports = __webpack_public_path__ + "static/media/LandingPageBackground02.7321d613.png";